import React from 'react';
import {
  Box,
  Controller,
  FieldWrapper,
  FormFieldsContainer,
  Inscription,
  Label,
  PriceInput,
  useFormContext,
} from '@common-fe/common-fe';
import _ from 'lodash';
import styled from 'styled-components';

import { ExcessContributionFormData, ExcessContributionFormField } from './useExcessContributionForm';

const StyledLabel = styled(Label)`
  > div {
    min-width: 244px;
  }
`;

interface Props {
  isEditMode?: boolean;
}

export const ExcessContributionForm: React.FC<Props> = ({ isEditMode }) => {
  const {
      control,
      formState: { errors },
    } = useFormContext<ExcessContributionFormData>();

  return (
    <Box data-testId="ExcessContributionForm" pad="spacing24">
      <FormFieldsContainer>
        <FieldWrapper>
          <StyledLabel name={ExcessContributionFormField.excessAmount} showRequireIcon isNarrow>
            Excess amount
            <Box margin={{ left: '-10px', top: 'spacing2' }} pad={{ right: 'spacing4' }}>
              <Inscription size="small" weight="normal" lineHeight="18px" color="textSecondary">
                Amount entered will be debited from your HSA.
              </Inscription>
            </Box>
          </StyledLabel>
          <Controller
            name={ExcessContributionFormField.excessAmount}
            control={control}
            render={({ field: { value, onChange } }) => (
              <PriceInput
                value={value}
                onChange={onChange}
                testId={ExcessContributionFormField.excessAmount}
                name={ExcessContributionFormField.excessAmount}
                placeholder="Enter $ amount"
                errorText={_.get(errors, `${ExcessContributionFormField.excessAmount}.message`)}
                disabled={!isEditMode}
              />
            )}
          />
        </FieldWrapper>

        <FieldWrapper>
          <StyledLabel name={ExcessContributionFormField.excessEarningsAmount} showRequireIcon isNarrow>
            Excess earnings
            <Box margin={{ left: '-10px', top: 'spacing2' }} pad={{ right: 'spacing4' }}>
              <Inscription size="small" weight="normal" lineHeight="18px" color="textSecondary">
                Excess earnings include any additional earnings due to the excess contributions, including but not limited to interest or investment earnings. Please consult with your tax advisor for additional assistance.
              </Inscription>
            </Box>
          </StyledLabel>
          <Controller
            name={ExcessContributionFormField.excessEarningsAmount}
            control={control}
            render={({ field: { value, onChange } }) => (
              <PriceInput
                value={value}
                onChange={onChange}
                testId={ExcessContributionFormField.excessEarningsAmount}
                name={ExcessContributionFormField.excessEarningsAmount}
                placeholder="Enter $ amount"
                errorText={_.get(errors, `${ExcessContributionFormField.excessEarningsAmount}.message`)}
                disabled={!isEditMode}
              />
            )}
          />
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};
